@if (membership(); as membership) {

<p class="confirm-membership__intro text-center">
  @if (selectedOn()) {
  You picked a membership on {{ selectedOn() }}. Saving a card will start it and charge you today.
  } @else {
  Saving a card will start the membership you picked and charge you today.
  }
</p>

<div class="confirm-membership__options" role="radiogroup" aria-label="Membership options">

  <button type="button" class="confirm-membership__option" role="radio"
    [attr.aria-checked]="selectedId() === membership.id" [class.is-selected]="selectedId() === membership.id"
    (click)="select(membership.id)">
    @if (alternatives().length) {
    <span class="confirm-membership__radio" aria-hidden="true"></span>
    }
    <span class="confirm-membership__option-text">
      <span class="confirm-membership__option-name">{{ membership.name }}</span>
      @if (renewalLabel(membership); as renewal) {
      <span class="confirm-membership__option-note">{{ renewal }}</span>
      }
    </span>
    <span class="confirm-membership__option-price">{{ membership.cost | currency }}</span>
  </button>

  @for (alternative of alternatives(); track alternative.id) {
  <button type="button" class="confirm-membership__option" role="radio"
    [attr.aria-checked]="selectedId() === alternative.id" [class.is-selected]="selectedId() === alternative.id"
    (click)="select(alternative.id)">
    <span class="confirm-membership__radio" aria-hidden="true"></span>
    <span class="confirm-membership__option-text">
      <span class="confirm-membership__option-name">{{ alternative.name }}</span>
      <span class="confirm-membership__option-note">
        @if (alternative.isFree) {
        Free &middot; no membership charge
        } @else {
        {{ renewalLabel(alternative) }}
        }
      </span>
    </span>
    <span class="confirm-membership__option-price">{{ alternative.cost | currency }}</span>
  </button>
  }

</div>

<div class="confirm-membership__total">
  <span>Charged today when you save your card</span>
  <strong>{{ total() | currency }}</strong>
</div>

@if (otherDueBalance() > 0) {
<p class="confirm-membership__due text-center">
  This includes {{ otherDueBalance() | currency }} already due on your account.
</p>
}

<div class="confirm-membership__actions">
  <button type="button" class="btn btn-outline-primary" (click)="notNow()">Not now</button>
  <button type="button" class="btn btn-primary" [disabled]="!hasSelection()" (click)="confirm()">
    {{ confirmButtonText() }}
  </button>
</div>

}
